import { useCallback, useRef } from 'react';

export type LatestEdit = {
  begin: () => number;
  isLatest: (edit: number) => boolean;
};

/**
 * Per-instance sequence for "only the newest edit may apply its result", so a
 * response that arrives after the user has already moved on is discarded.
 *
 * @example
 *   const { begin, isLatest } = useLatestEdit();
 *   const edit = begin();
 *   // ...later, when the write settles
 *   if (isLatest(edit)) applyResult();
 */
export function useLatestEdit(): LatestEdit {
  const latest = useRef(0);

  const begin = useCallback(() => {
    latest.current += 1;
    return latest.current;
  }, []);

  const isLatest = useCallback((edit: number) => latest.current === edit, []);

  return { begin, isLatest };
}
